import { track } from '../lib/analytics';
// @ts-expect-error -- plain .mjs with no type declarations
import { C as SHELL } from '../../scripts/lib/shell.mjs';

const POPULAR_WARDS: { name: string; slug: string }[] = [
  { name: '港区', slug: 'minato' },
  { name: '渋谷区', slug: 'shibuya' },
  { name: '新宿区', slug: 'shinjuku' },
  { name: '世田谷区', slug: 'setagaya' },
  { name: '千代田区', slug: 'chiyoda' },
  { name: '中央区', slug: 'chuo' },
];

const FLOOR_PLAN_RANKINGS: { label: string; slug: string }[] = [
  { label: '1K', slug: '1k' },
  { label: '1LDK', slug: '1ldk' },
  { label: '2LDK', slug: '2ldk' },
  { label: '3LDK', slug: '3ldk' },
  { label: '4LDK', slug: '4ldk' },
];

const AREA_INDEXES: { label: string; href: string; target: string }[] = [
  { label: '町丁目別（23区・約940地区）', href: '/areas/index.html', target: 'areas_index' },
  { label: '都道府県別', href: '/rankings/prefectures/index.html', target: 'pref_index' },
  { label: '主要都市別', href: '/rankings/cities/index.html', target: 'city_index' },
  // Points at the ranking index rather than a specific property type: the
  // 戸建て page exists only when the data supports it, and the index carries
  // the 中古マンション / 戸建て switcher either way.
  { label: '23区ランキング（中古マンション・戸建て）', href: '/rankings.html', target: 'rankings_overall' },
  { label: 'エリアガイド一覧', href: '/articles.html', target: 'articles_index' },
];

const utm = (campaign: string) => `?utm_source=spa&utm_medium=link&utm_campaign=${campaign}`;

// The site's pill, from the module the generators use, so the map panel's
// chips and the ranking pages' chips cannot drift apart.
const tag: string = SHELL.tag;

export default function ExploreLinks() {
  const onClick = (target: string) => () => track('explore_link_click', { target });

  return (
    <section>
      <h2 className="section-title">相場を一覧で見る</h2>

      <ul className="mt-3 divide-y divide-rule border-y border-rule">
        {AREA_INDEXES.map((a) => (
          <li key={a.target}>
            <a
              href={`${a.href}${utm(`spa_${a.target}`)}`}
              onClick={onClick(a.target)}
              className="flex items-baseline justify-between py-2.5 text-[13px] font-bold text-ink-2 transition-colors hover:text-primary-text"
            >
              <span>{a.label}</span>
              <span aria-hidden="true" className="text-primary">→</span>
            </a>
          </li>
        ))}
      </ul>

      <div className="mt-4">
        <p className="field-label">間取り別ランキング</p>
        <div className="flex flex-wrap gap-1.5">
          {FLOOR_PLAN_RANKINGS.map((p) => (
            <a
              key={p.slug}
              href={`/rankings/${p.slug}.html${utm(`spa_rankings_${p.slug}`)}`}
              onClick={onClick(`rankings_${p.slug}`)}
              className={tag}
            >
              {p.label}
            </a>
          ))}
        </div>
      </div>

      <div className="mt-4">
        <p className="field-label">よく見られている区</p>
        <div className="flex flex-wrap gap-1.5">
          {POPULAR_WARDS.map((w) => (
            <a
              key={w.slug}
              href={`/wards/${w.slug}.html${utm(`spa_ward_${w.slug}`)}`}
              onClick={onClick(`ward_${w.slug}`)}
              className={tag}
            >
              {w.name}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
